module.exports = __webpack_public_path__ + "static/media/41.2bcd9f99.png";